<div class="subscription-main">
    <app-header></app-header>
    <div class="inner_cms_layout">
        <div class="container">
            <div class="subscription-fixed-width">
                <div class="subscription-head">
                    <h4>Plans & Pricing</h4>
                    <h6>
                        All CredExchange pricing plans come with a 7‑day free trial on the
                        PRO plan. No credit card required.
                    </h6>
                </div>
                <ul class="nav nav-tabs subscription-tab" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation" *ngFor="let item of plan">
                        <button class="nav-link" id="{{ item.plan }}-tab" data-bs-toggle="tab"
                            [attr.data-bs-target]="'#' + item.plan" type="button" role="tab"
                            [attr.aria-controls]="item.plan"
                            [attr.aria-selected]="actTab === item.plan ? 'true' : 'false'"
                            [ngClass]="{ 'active': actTab === item.plan }" (click)="setActTab(item.plan)">
                            {{ item?.value }}
                        </button>
                    </li>
                    <!-- <li class="nav-item" role="presentation" >
                        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home"
                            type="button" role="tab" aria-controls="home" aria-selected="true">
                            12 months
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile"
                            type="button" role="tab" aria-controls="profile" aria-selected="false">
                            1 months
                        </button>
                    </li> -->
                </ul>

                <div class="tab-content subscription-tabcontent">
                    <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div class="subscription-box-head">
                            <div class="subscription-box" *ngFor="let item of subsData">
                                <div>
                                    <div class="subscription-title">
                                        <h6>{{firstCapital(item.title)}}</h6>
                                        <p>{{ item.title === 'basic' ? 'Essential features for aspiring traders' :
                                            item.title === 'advanced' ? 'A full-featured suite for seasoned traders' :
                                            'Maximum performance and versatility for expert traders' }}</p>
                                        <h5>${{item.amount}} <span>/ {{ item.planType }} month</span></h5>
                                    </div>
                                    <div class="subscription-card">
                                        <p>
                                            <img src="../../../assets/images/grid-bot.png" alt="" img="img-fluid"
                                                class="me-2" />{{item.gridCount}} Active Grid bots
                                        </p>
                                        <p>
                                            <img src="../../../assets/images/trade-bot.png" alt="" img="img-fluid"
                                                class="me-2" />{{item.dcaCount}} Active DCA bots
                                        </p>
                                    </div>
                                    <div class="subscription-list">
                                        <ul>
                                            <li>Unlimited Manual trading</li>
                                            <li>Unlimited Smart orders</li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="subscription-box-button">
                                    <button (click)="submitForm(item)">Start Now</button>
                                </div>
                                <div class="subscription-box-button yellow-btn">
                                    <button [disabled]="true" >
                                        Purchased </button>
                                </div>
                                <div class="subscription-box-button blue-btn">
                                    <button [disabled]="true">Upgrade Now</button>
                                </div>
                                <div class="highlight-text">
                                    <p>You already have a higher subscription</p>
                                </div> -->
                                <!-- <div *ngIf="purchaseStatus == 'not_purchased'" class="subscription-box-button">
                                    <button (click)="submitForm(item)">Start Now</button>
                                </div> -->
                                <div *ngIf="purchaseStatus == 'not_purchased'" class="subscription-box-button "
                                    data-bs-toggle="modal" data-bs-target="#confirm_enable_modal">
                                    <button (click)="setData(item)"> Start Now</button>
                                </div>
                                <div *ngIf="purchaseStatus === 'purchased' && item._id === purchaseDet?.planId"
                                    class="subscription-box-button yellow-btn">
                                    <button [disabled]="true">
                                        Purchased </button>
                                </div>
                                <!-- <div *ngIf="purchaseStatus === 'purchased' && parseAmount(item.amount) > parseAmount(purchaseDet?.amount)"
                                    class="subscription-box-button blue-btn">
                                    <button (click)="upgradeForm(item)">Upgrade Now</button>
                                </div> -->
                                <div *ngIf="purchaseStatus === 'purchased' && parseAmount(item.amount) > parseAmount(purchaseDet?.amount)"
                                    class="subscription-box-button blue-btn" data-bs-toggle="modal"
                                    data-bs-target="#upgrade_enable_modal">
                                    <button (click)="setData(item)"> Upgrade Now</button>
                                </div>
                                <div *ngIf="purchaseStatus === 'purchased' && parseAmount(purchaseDet?.amount) >
                                    parseAmount(item.amount)" class="highlight-text">
                                    <p>You already have a higher subscription</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!-- Upgrade Enable Modal -->
<div class="modal fade primary_modal" id="upgrade_enable_modal" tabindex="-1"
    aria-labelledby="upgrade_enable_modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="upgrade_enable_modalLabel">Confirm Purchase</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-2">
                    <label>Are you sure to upgrade this plan</label>
                </div>

                <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" id="upgradeCheck" [(ngModel)]="upgradeChecked">
                    <label class="form-check-label" for="upgradeCheck">
                        I agree to the Terms and Conditions
                    </label>
                </div>

                <div class="mb-2">
                    <button class="btn btn-link p-0" type="button" (click)="showUpgradeTerms = !showUpgradeTerms">
                        {{ showUpgradeTerms ? 'Hide' : 'View' }} Terms and Conditions
                    </button>
                </div>

                <div *ngIf="showUpgradeTerms" class="border p-2 rounded mb-3" style="max-height: 200px; overflow-y: auto; font-size: 14px;">
                    <p><strong>By subscribing to and utilizing the CredBull Bot services, you represent and warrant that you have read and agreed to the following Terms & Conditions:</strong></p>
                    <p><strong>Profits & Losses:</strong> Trading carries high risk. Any profits or losses realized when utilizing the trading bots are your responsibility. We highly recommend that you completely understand the nature of the risks involved in cryptocurrency trading before using the bots.</p>
                    <p><strong>Legal Compliance:</strong> CredBull Exchange complies with all the laws, regulations, and guidelines of the Indian government, including but not limited to the Prevention of Money Laundering Act (PMLA) and tax laws. It is your responsibility to ensure your trading activities are in line with these laws and regulations.</p>
                    <p><strong>Taxation:</strong> All profits made from trading or by using bots are taxable under Indian law. You are entirely on your own when it comes to reporting your income to the relevant tax authorities and paying any tax that may be due on your crypto transactions.</p>
                    <p><strong>No Liability:</strong> CredBull Exchange cannot guarantee profits, and it disclaims any liability for financial losses, technical failures, or legal liabilities resulting from the use of trading bots. We are not responsible for any legal issues or disputes arising out of users' activities, and it is your obligation to comply with all the legal requirements.</p>
                    <p><strong>Acknowledgment:</strong> By becoming a subscriber to the service, you acknowledge that you have read, understood, and agreed to these Terms & Conditions, including the risks of using trading bots, and that you will adhere to all applicable legal and regulatory requirements.</p>
                </div>

                <div>
                    <button class="trade_buy_btn my-2" type="button" (click)="upgradeForm()" [disabled]="!upgradeChecked">
                        Confirm
                    </button>
                    <button class="trade_sell_btn" type="button" data-bs-dismiss="modal" aria-label="Close">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Confirm Enable Modal -->
<div class="modal fade primary_modal" id="confirm_enable_modal" tabindex="-1"
    aria-labelledby="confirm_enable_modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="confirm_enable_modalLabel">Confirm Purchase</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-2">
                    <label>Are you sure to purchase this plan</label>
                </div>

                <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" id="confirmCheck" [(ngModel)]="purchaseChecked">
                    <label class="form-check-label" for="confirmCheck">
                        I agree to the Terms and Conditions
                    </label>
                </div>

                <div class="mb-2">
                    <button class="btn btn-link p-0" type="button" (click)="showPurchaseTerms = !showPurchaseTerms">
                        {{ showPurchaseTerms ? 'Hide' : 'View' }} Terms and Conditions
                    </button>
                </div>

                <div *ngIf="showPurchaseTerms" class="border p-2 rounded mb-3" style="max-height: 200px; overflow-y: auto; font-size: 14px;">
                    <p><strong>By subscribing to and utilizing the CredBull Bot services, you represent and warrant that you have read and agreed to the following Terms & Conditions:</strong></p>
                    <p><strong>Profits & Losses:</strong> Trading carries high risk. Any profits or losses realized when utilizing the trading bots are your responsibility. We highly recommend that you completely understand the nature of the risks involved in cryptocurrency trading before using the bots.</p>
                    <p><strong>Legal Compliance:</strong> CredBull Exchange complies with all the laws, regulations, and guidelines of the Indian government, including but not limited to the Prevention of Money Laundering Act (PMLA) and tax laws. It is your responsibility to ensure your trading activities are in line with these laws and regulations.</p>
                    <p><strong>Taxation:</strong> All profits made from trading or by using bots are taxable under Indian law. You are entirely on your own when it comes to reporting your income to the relevant tax authorities and paying any tax that may be due on your crypto transactions.</p>
                    <p><strong>No Liability:</strong> CredBull Exchange cannot guarantee profits, and it disclaims any liability for financial losses, technical failures, or legal liabilities resulting from the use of trading bots. We are not responsible for any legal issues or disputes arising out of users' activities, and it is your obligation to comply with all the legal requirements.</p>
                    <p><strong>Acknowledgment:</strong> By becoming a subscriber to the service, you acknowledge that you have read, understood, and agreed to these Terms & Conditions, including the risks of using trading bots, and that you will adhere to all applicable legal and regulatory requirements.</p>
                </div>

                <div>
                    <button class="trade_buy_btn my-2" type="button" (click)="submitForm()" [disabled]="!purchaseChecked">
                        Confirm
                    </button>
                    <button class="trade_sell_btn" type="button" data-bs-dismiss="modal" aria-label="Close">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


